<ng-container *ngIf="offerId$ | async as offerId">
	<offers-my_offers_offer_details [attr.offer-id]="offerId"></offers-my_offers_offer_details>
</ng-container>
